/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeIssueStatusSchema, type IChallengeIssueStatus } from '../enums';

const flagDataSchema = z.object({
  issueId: z.number(),
  status: challengeIssueStatusSchema,
});

export interface IFlagCollectionTriageClipData {
  issueId: number;
  status: IChallengeIssueStatus;
}

export const flagCollectionTriageClipResponseSchema = createApiResponseSchema(
  flagDataSchema,
) as z.ZodSchema<IAPI<IFlagCollectionTriageClipData>>;

export type IFlagCollectionTriageClipResponse = IAPI<IFlagCollectionTriageClipData>;
